import { Permission } from "../../../common/security/enums";
import { hasAllPermissions, hasAnyPermission } from "../../../common/security/utils";
import { usePermissions } from "../hooks";

interface Props {
  children: React.ReactNode;
  permissions: Permission[];
  anyPermissionPresent?: boolean;
}

const ComponentWithPermission = ({ permissions, anyPermissionPresent, children }: Props) => {
  const accountPermissions = usePermissions();

  return (
    anyPermissionPresent
      ? hasAnyPermission(accountPermissions, permissions)
      : hasAllPermissions(accountPermissions, permissions)
  ) ? (
    <>{children}</>
  ) : null;
};

export default ComponentWithPermission;
